import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {LeadCommentTagsActions} from '../store';
import {LeadCommentTagsSelectors} from '../store/selectors';

@Injectable()
export class LeadCommentTagsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadLeadCommentTags().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadLeadCommentTags() {
    return this.store.pipe(
      select(LeadCommentTagsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(LeadCommentTagsActions.LoadLeadCommentTags());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
